<template>
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.5 3.98389H12V2.48389C12 1.67139 11.3125 0.983887 10.5 0.983887H5.5C4.65625 0.983887 4 1.67139 4 2.48389V3.98389H1.5C0.65625 3.98389 0 4.67139 0 5.48389V13.4839C0 14.3276 0.65625 14.9839 1.5 14.9839H14.5C15.3125 14.9839 16 14.3276 16 13.4839V5.48389C16 4.67139 15.3125 3.98389 14.5 3.98389ZM5.5 2.48389H10.5V3.98389H5.5V2.48389ZM1.5 13.4839V5.48389H4V13.4839H1.5ZM5.5 13.4839V5.48389H10.5V13.4839H5.5ZM14.5 13.4839H12V5.48389H14.5V13.4839Z" />
  </svg>
</template>
